export default {
  siteTitle: 'EUSO',
  siteUrl: 'https://www.string.eusa.ed.ac.uk',
  siteLogo: '/logo.png',
  description:
    'The official website of the Edinburgh University String Orchestra',
  userTwitter: 'EdinStrings',
}
